export const LED_MODE_TYPES = {
    DAY_MODE: 'DAY_MODE',
    NIGHT_MODE: 'NIGHT_MODE',
    STEALTH_MODE: 'STEALTH_MODE',
    UNKNOWN_MODE: 'UNKNOWN_MODE',
};
